export default __webpack_public_path__ + "static/media/home-business-slider-img02.574b2c1f.jpg";